import React, { useEffect, useState, createElement } from 'react';
import { Flame, CheckCircle2, XCircle, ShieldCheck, Download, Lock, Clock, Sparkles, MessageSquare, AlertTriangle, Package, DollarSign } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ThankYouDownsalePage() {
  // 15-minute countdown
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'ThankYou-Downsale-View');
    // Countdown
    const interval = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (s: number) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };
  return <div className="min-h-screen bg-[#0a0e1a] text-white font-sans selection:bg-amber-400 selection:text-black" data-id="element-4140">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-4141">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-4142" />
      </noscript>

      {/* Urgency Top Bar */}
      <div className="sticky top-0 z-50 bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 text-black py-2.5 px-4 shadow-lg" data-id="element-4143">
        <div className="max-w-5xl mx-auto flex items-center justify-center gap-2 md:gap-3 text-center" data-id="element-4144">
          <Flame className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 animate-pulse" data-id="element-4145" />
          <p className="text-[11px] sm:text-xs md:text-sm font-black uppercase tracking-wide" data-id="element-4146">
            ÚLTIMA OPORTUNIDAD — EXPIRA EN{' '}
            <span className="font-mono bg-black text-amber-400 px-2 py-0.5 rounded ml-1 tabular-nums" data-id="element-4147">
              {formatTime(timeLeft)}
            </span>
          </p>
        </div>
      </div>

      {/* Registration Incomplete Alert — keeps visitors on page */}
      <div className="bg-red-600 py-2 px-4" data-id="element-4148">
        <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-center" data-id="element-4149">
          <AlertTriangle className="w-3.5 h-3.5 md:w-4 md:h-4 text-yellow-300 flex-shrink-0 animate-pulse" data-id="element-4150" />
          <p className="text-white font-bold text-[11px] sm:text-xs md:text-sm uppercase tracking-tight leading-tight" data-id="element-4151">
            Tu registración al webinar no está completa aún
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8 md:py-12 lg:py-16" data-id="element-4152">
        {/* Hero Section */}
        <section className="text-center mb-10 md:mb-14 lg:mb-16" data-id="element-4153">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-5 md:mb-6" data-id="element-4154">
            <Sparkles className="w-3.5 h-3.5 text-amber-400" data-id="element-4155" />
            <span className="text-amber-400 text-[11px] md:text-sm font-bold uppercase tracking-widest" data-id="element-4156">
              Una sola oferta más antes de irte
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-[1.1] tracking-tight mb-5 md:mb-6" data-id="element-4157">
            Espera —{' '}
            <span className="text-amber-400" data-id="element-4158">
              Antes de Irte, Tengo Algo Más
            </span>
          </h1>

          <div className="flex justify-center mb-6 md:mb-8" data-id="element-4159">
            <img src="https://cdn.magicpatterns.com/uploads/fnSrv3cQGqXfuDMy26kNxi/100_Mensajes.png" alt="100 Mensajes de WhatsApp — Versión LITE" className="w-full max-w-lg md:max-w-2xl h-auto rounded-2xl shadow-[0_25px_70px_-15px_rgba(0,0,0,0.7)] ring-1 ring-white/10" data-id="element-4160" />
          </div>

          <p className="text-base md:text-lg lg:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-4161">
            Entiendo que <span className="text-white font-bold" data-id="element-4162">$27</span>{' '}
            quizás no era el momento. Pero no quiero que llegues al webinar{' '}
            <span className="text-white font-bold" data-id="element-4163">
              sin los mensajes esenciales.
            </span>
          </p>
        </section>

        {/* LITE Version Section */}
        <section className="mb-10 md:mb-14" data-id="element-4164">
          <div className="bg-gradient-to-br from-amber-950/40 to-[#0a0e1a] border border-amber-500/30 rounded-2xl p-6 sm:p-8 md:p-10 lg:p-12" data-id="element-4165">
            <div className="flex items-start gap-3 md:gap-4 mb-6 md:mb-8" data-id="element-4166">
              <div className="w-11 h-11 md:w-12 md:h-12 bg-amber-500/10 border border-amber-500/30 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-4167">
                <Package className="w-5 h-5 md:w-6 md:h-6 text-amber-400" data-id="element-4168" />
              </div>
              <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-black text-white leading-tight pt-0.5" data-id="element-4169">
                Te Tengo La <span className="text-amber-400" data-id="element-4170">Versión LITE</span>{' '}
                del Manual
              </h2>
            </div>

            {/* What's included / not included — side by side on desktop */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-6 md:mb-8" data-id="element-4171">
              {/* SÍ incluye */}
              <div data-id="element-4172">
                <div className="flex items-center gap-2 mb-4" data-id="element-4173">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-emerald-400 flex-shrink-0" data-id="element-4174" />
                  <p className="text-white font-bold text-base md:text-lg" data-id="element-4175">
                    Lo que SÍ incluye:
                  </p>
                </div>
                <ul className="space-y-3 text-gray-300 text-sm md:text-base lg:text-lg" data-id="element-4176">
                  <li className="flex items-start gap-3" data-id="element-4177">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-emerald-400 flex-shrink-0 mt-1" data-id="element-4178" />
                    <span data-id="element-4179">
                      <span className="text-white font-bold" data-id="element-4180">100 mensajes</span>{' '}
                      (los esenciales — los más probados)
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4181">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-emerald-400 flex-shrink-0 mt-1" data-id="element-4182" />
                    <span data-id="element-4183">
                      Cubre los{' '}
                      <span className="text-white font-bold" data-id="element-4184">
                        6 nichos principales
                      </span>
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4185">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-emerald-400 flex-shrink-0 mt-1" data-id="element-4186" />
                    <span data-id="element-4187">
                      Incluye las{' '}
                      <span className="text-white font-bold" data-id="element-4188">
                        5 Reglas de Oro del WhatsApp
                      </span>
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4189">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-emerald-400 flex-shrink-0 mt-1" data-id="element-4190" />
                    <span data-id="element-4191">
                      <span className="text-white font-bold" data-id="element-4192">
                        Misma garantía de 7 días
                      </span>
                    </span>
                  </li>
                </ul>
              </div>

              {/* NO incluye */}
              <div data-id="element-4193">
                <div className="flex items-center gap-2 mb-4" data-id="element-4194">
                  <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-400 flex-shrink-0" data-id="element-4195" />
                  <p className="text-white font-bold text-base md:text-lg" data-id="element-4196">
                    Lo que NO incluye:
                  </p>
                </div>
                <ul className="space-y-3 text-gray-400 text-sm md:text-base lg:text-lg" data-id="element-4197">
                  <li className="flex items-start gap-3" data-id="element-4198">
                    <XCircle className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-4199" />
                    <span data-id="element-4200">Los otros 100 mensajes de situaciones avanzadas</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4201">
                    <XCircle className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-4202" />
                    <span data-id="element-4203">La plantilla editable en Google Docs</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4204">
                    <XCircle className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-4205" />
                    <span data-id="element-4206">Acceso a futuras actualizaciones</span>
                  </li>
                </ul>
              </div>
            </div>

            <p className="text-gray-300 text-sm md:text-base lg:text-lg leading-relaxed border-l-2 border-amber-400 pl-4 italic" data-id="element-4207">
              Pero tienes lo{' '}
              <span className="text-white font-bold not-italic" data-id="element-4208">
                SUFICIENTE para arrancar el jueves
              </span>{' '}
              después del webinar y cerrar tus primeros clientes.
            </p>
          </div>
        </section>

        {/* CTA + Pricing */}
        <section className="mb-8" data-id="element-4209">
          <div className="bg-gradient-to-br from-[#0f1729] to-[#0a0e1a] border-2 border-amber-500/40 rounded-2xl p-6 sm:p-8 md:p-10 lg:p-12 shadow-[0_0_50px_rgba(245,158,11,0.15)]" data-id="element-4210">
            {/* Price summary */}
            <div className="text-center mb-7 md:mb-8" data-id="element-4211">
              <div className="inline-flex items-center gap-1.5 text-gray-400 text-sm md:text-base mb-2" data-id="element-4212">
                <DollarSign className="w-4 h-4 md:w-[18px] md:h-[18px] text-amber-400" data-id="element-4213" />
                <span data-id="element-4214">Inversión única</span>
              </div>
              <p className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white mb-2 leading-none" data-id="element-4215">
                $17{' '}
                <span className="text-lg md:text-2xl text-gray-500 font-medium align-top" data-id="element-4216">
                  USD
                </span>
              </p>
              <p className="text-amber-400 text-sm md:text-base font-semibold" data-id="element-4217">
                Pago único · Descarga inmediata
              </p>
            </div>

            {/* Main CTA Button */}
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/wKOVJ" target="_blank" rel="noopener noreferrer" className="group block w-full" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'InitiateCheckout', {
                value: 17,
                currency: 'USD'
              });
            }
          }} data-id="element-4218">
              <button className="relative w-full bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-400 hover:to-amber-300 text-[#0a0e1a] font-black text-sm sm:text-base md:text-lg lg:text-xl uppercase tracking-tight py-5 md:py-6 lg:py-7 px-4 sm:px-6 rounded-xl shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden" data-id="element-4219">
                <span className="relative z-10 flex items-center justify-center gap-2 md:gap-3 flex-wrap" data-id="element-4220">
                  <MessageSquare className="w-5 h-5 md:w-6 md:h-6" data-id="element-4221" />
                  LLEVARME LA VERSIÓN LITE POR $17
                </span>
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-4222" />
              </button>
            </a>

            {/* Microcopy */}
            <div className="mt-5 flex items-center justify-center gap-x-4 gap-y-2 flex-wrap text-xs md:text-sm text-gray-400" data-id="element-4223">
              <span className="flex items-center gap-1.5" data-id="element-4224">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-4225" />
                Descarga inmediata
              </span>
              <span className="flex items-center gap-1.5" data-id="element-4226">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-4227" />
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-4228">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-4229" />
                Pago seguro
              </span>
            </div>

            {/* Downsell link — right under the CTA so users don't miss the next step */}
            <div className="text-center mt-4" data-id="element-4230">
              <Link to="/thank-you" className="text-white hover:text-gray-200 text-sm md:text-base underline underline-offset-4 transition-colors" data-id="element-4231">
                No gracias, solo quiero ir al webinar →
              </Link>
            </div>

            {/* Guarantee Block */}
            <div className="mt-7 md:mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center gap-4" data-id="element-4232">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-emerald-500/10 rounded-full flex items-center justify-center border border-emerald-500/20 flex-shrink-0" data-id="element-4233">
                <ShieldCheck className="w-7 h-7 md:w-8 md:h-8 text-emerald-400" data-id="element-4234" />
              </div>
              <div className="text-center sm:text-left" data-id="element-4235">
                <h4 className="text-white font-bold text-base md:text-lg mb-1" data-id="element-4236">
                  Misma Garantía: 7 Días
                </h4>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed" data-id="element-4237">
                  100% reembolso si no te sirve. Sin preguntas, sin letra
                  pequeña.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Trust footer note */}
        <div className="text-center text-gray-600 text-xs md:text-sm pt-6" data-id="element-4238">
          <Clock className="w-4 h-4 inline mr-1.5 mb-0.5" data-id="element-4239" />
          Esta oferta no estará disponible después de salir de esta página.
        </div>
      </main>

      <Footer data-id="element-4240" />
    </div>;
}